import React from 'react';
import NotificationIcon from '@mui/icons-material/Notifications';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import clsx from 'clsx';
import { Button } from '@mui/material';
import NotifButtonWrapper from './Components/NotifButtonWrapper';
import NotificationMenu from './Components/NotificationMenu';

export default function NotificationButton() {
  const [notifAnchorEl, setNotifAnchorEl] = React.useState<null | HTMLElement>(null);

  return (
    <>
      <Button
        disableElevation
        disableRipple
        className={clsx({ active: !!notifAnchorEl })}
        onClick={(e) => { setNotifAnchorEl(e.currentTarget); }}
      >
        <NotifButtonWrapper>
          {notifAnchorEl ? <NotificationIcon /> : <NotificationsNoneIcon />}
        </NotifButtonWrapper>
      </Button>
      <NotificationMenu anchorEl={notifAnchorEl} setAnchorEl={setNotifAnchorEl} />
    </>
  );
}
